<app-overlay
  *ngIf="this.isLoading"
>
</app-overlay>

<div
  class="h-screen bg-neutral-50 min-h-fit bg-[url('/dkv-2023-308.jpg')] bg-no-repeat bg-bottom bg-cover"
>
  <div class="pt-12">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white px-4 py-8 shadow-2xl sm:rounded-lg sm:px-10">

        <img
          class="mx-auto h-16 w-auto mt-3 mb-5"
          src="/dkv-logo.png"
          alt="DKV"
        />

        <div
          *ngIf="this.isSent"
          class="flex justify-end"
        >
          Vielen Dank - wir werden Ihre Nachricht in Kürze beantworten.
        </div>

        <div
          *ngIf="this.missingFieldForm?.completed"
          class="flex justify-end"
        >
          Ihre Kundennummer wurde erfolgreich übernommen. Unser Kundenservice wird sich schnellst möglich um Ihr Anliegen kümmern.
        </div>

        <div
          *ngIf="!this.missingFieldForm?.completed && this.missingFieldForm?.formOlderOneDay()"
          class="flex justify-end"
        >
          Unser Kundenservice kümmert sich bereits um Ihr Anliegen. Sie werden in Kürze eine Antwort erhalten.
        </div>

        <div
          *ngIf="this.missingFieldForm && !this.isSent && !this.missingFieldForm?.completed && !this.missingFieldForm?.formOlderOneDay()"
        >
          <br>
          <div><b>{{ this.missingFieldForm?.formSubject }}</b></div>
          <br>
          <div>E-Mail: {{ this.missingFieldForm?.emailSubject }} vom {{ this.missingFieldForm?.emailDate }}</div>
          <br>
          <div [innerHTML]="this.missingFieldForm?.formTemplate"></div>
          <br>

          <form
            class="space-y-6"
            action="#"
            method="POST"
          >
            <div *ngFor="let missingField of this.missingFieldForm?.missingFields">
              <label
                for="{{ missingField }}"
                class="block text-sm font-medium leading-6 text-gray-900"
              >{{ missingField.fieldLabel }}</label
              >
              <div class="relative mt-2 rounded-md shadow-sm">
                <div
                  class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                >
                  <svg
                    class="h-4 w-4 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z"
                    />
                    <path
                      d="M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z"
                    />
                  </svg>
                </div>
                <input
                  matInput
                  id="{{ missingField.fieldId }}"
                  name="{{ missingField.fieldId }}"
                  [(ngModel)]="missingField.fieldValue"
                  class="focus:outline-none block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#CB7FD9] sm:text-sm sm:leading-6"
                  required
                  [disabled]="this.isInputDisabled"
                />
              </div>
            </div>

            <div class="flex justify-end">
            </div>

            <div>
              <button
                *ngIf="!this.isSent"
                [disabled]="!this.isValid()"
                (click)="this.sendForm(); false;"
                class="flex w-full justify-center rounded-md bg-[#f18400] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#001B65] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600 shadow-xl"
              >
                {{ "Daten absenden" }}
              </button>
              <br>
              <a
                href="https://www.dkv-mobility.com/de/de/imprint/"
                target="_blank"
                class="flex justify-center rounded-md hover:text-[#f18400]"
              >
                Impressum
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
